import React from "react";
import { ReactComponent as FooterLogo } from "../assets/images/footer/footer-logo.svg";
import { ReactComponent as FbLogo } from "../assets/images/footer/fb-logo.svg";
import { ReactComponent as MLogo } from "../assets/images/footer/m-logo.svg";
import { ReactComponent as Twitter } from "../assets/images/footer/twitter-logo.svg";
import { ReactComponent as LinkedinLogo } from "../assets/images/footer/linkedin-logo.svg";
import { ReactComponent as AdressImg } from "../assets/images/footer/adress-img.svg";
import { ReactComponent as EmailImg } from "../assets/images/footer/email-img.svg";
import { ReactComponent as CapteraLogo } from "../assets/images/footer/capterra-logo.svg";
import { ReactComponent as GetAppLogo } from "../assets/images/footer/get-app-logo.svg";
import { ReactComponent as Point } from "../assets/images/footer/footer-point.svg";

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <div className="row mt-5 pt-3">
          <div className="col-sm-2  col-mid-2col-lg-3">
            <FooterLogo className="footer-logo" />
            <div className="social-media-icons mt-4">
              <FbLogo className="me-2" onClick={() => (window.location.href = "#")} />
              <MLogo className="me-2" onClick={() => (window.location.href = "#")} />
              <LinkedinLogo className="me-2" onClick={() => (window.location.href = "#")} />
              <Twitter className="me-2" onClick={() => (window.location.href = "#")} />
            </div>
          </div>
          <div className="col">
            <p>Technology</p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                <a href="https://www.textunited.com/technology/translation-software/">Translation Software</a>
              </li>
              <li className="list-group-item">
                <a href="#">Translation System</a>
              </li>
              <li className="list-group-item">
                <a href="#">White Label</a>
              </li>
              <li className="list-group-item">
                <a href="#">Cat Tool</a>
              </li>
              <li className="list-group-item">
                <a href="https://api.textunited.com/index.html">API</a>
              </li>
              <li className="list-group-item">
                <a href="https://help.textunited.com/">Help</a>
              </li>
            </ul>
          </div>
          <div className="col">
            <p>Translation Software</p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                <a href="https://www.textunited.com/solutions/multilingual-customer-experience/">Multilingual CX</a>
              </li>
              <li className="list-group-item">
                <a href="https://www.textunited.com/solutions/website-translation/">Website Translation</a>
              </li>
              <li className="list-group-item">
                <a href="https://help.textunited.com/">E-Commerce Translation</a>
              </li>
              <li className="list-group-item">
                <a href="#">Software Localization</a>
              </li>
              <li className="list-group-item">
                <a href="https://www.textunited.com/solutions/elearning-education/">E-Learning Localization</a>
              </li>
            </ul>
          </div>
          <div className="col">
            <p>Translation Srvices</p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                <a href="https://www.textunited.com/solutions/elearning-education/">Project Management</a>
              </li>
              <li className="list-group-item">
                <a href="https://www.textunited.com/solutions/elearning-education/">Files And Data</a>
              </li>
              <li className="list-group-item">
                <a href="https://www.textunited.com/solutions/elearning-education/">Voiceover And Interpretation</a>
              </li>
            </ul>
          </div>
          <div className="col ">
            <p>Contact Us</p>
            <div className="row"></div>
            <ul className="contact-us list-unstyled">
              <li>
                {" "}
                {<AdressImg className="adress" />}
                <span className="">
                  Attemsgasse 7/D/20 <br></br> 1220 – Vienna <br></br> Austria
                </span>
              </li>
              <li>
                {" "}
                {<EmailImg className="email" />}
                <span>Servus@Textunited.com</span>
              </li>
            </ul>

            {/* <ul className="">
              <li className="list-group-item"></li>
              <li className="list-group-item"></li>
              
            </ul> */}
            <div className="row">{<CapteraLogo />}</div>
            <div className="row">{<GetAppLogo />}</div>
          </div>
        </div>

        <div className="row  pb-1">
          <div className="col-sm-2  col-mid-2col-lg-3"></div>
          <div className="col">
            <p>Join Us</p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                <a href="https://www.textunited.com/technology/translation-software/">LSP</a>
              </li>
              <li className="list-group-item">
                <a href="#">Translator</a>
              </li>
            </ul>
          </div>
          <div className="col">
            <p>Expertise</p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                <a href="https://www.textunited.com/solutions/multilingual-customer-experience/">Our Technologies</a>
              </li>
              <li className="list-group-item">
                <a href="https://www.textunited.com/solutions/website-translation/">Machine Translation</a>
              </li>
            </ul>
          </div>
          <div className="col">
            <p>Company</p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">
                <a href="https://www.textunited.com/solutions/elearning-education/">Contact</a>
              </li>
              <li className="list-group-item">
                <a href="https://www.textunited.com/solutions/elearning-education/">Blog</a>
              </li>
            </ul>
          </div>
          <div className="col">
            {/* <ul className="list-group list-group-flush">
              <li className="list-group-item">{<CapteraLogo />}</li>
              <li className="list-group-item"></li>
              <li className="list-group-item">{<GetAppLogo />}</li>
            </ul> */}
          </div>
        </div>
      </div>
      <div className="copyrights">
        <div className="container">
          <div className="row">
            <div className="col-sm-4">
              <p>© 2021 Text United GmbH / All rights reserved.</p>
            </div>
            <div className="col-sm-8">
              <div className="footer-links">
                <span>
                  <a href="https://www.textunited.com/privacy-policy/">Private Policy</a>&nbsp;&nbsp;{<Point />}&nbsp;&nbsp;
                </span>
                <span>
                  <a href="https://www.textunited.com/terms-conditions/">T&Cs</a>&nbsp;&nbsp; {<Point />}&nbsp;&nbsp;
                </span>
                <span>
                  <a href="https://www.textunited.com/legal-notice/">Legal Notice</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
